import React, { useContext } from 'react';
import VirtualAppointmentContext from './VirtualAppointmentContext';

export default () => useContext(VirtualAppointmentContext);
